import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react'
import Offcanvas from 'react-bootstrap/Offcanvas';
import Select from 'react-select';
import { customStyles } from '../../../../HelperFunctions';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import axios from 'axios';
import { adminMainUrl } from '../../../../Config';
import InputTextJSX from './InputTextJSX';
const AddOperationExpenseOffcanvas = ({
    b64id,
    show,
    handleClose,
    loadingExpenseType,
    expenseTypeOptions,
    currencyOptions,
    loadingCurrency,
    refresh,
}) => {

    const navigate = useNavigate();
    const [disableSubmit, setDisableSubmit] = useState(false);

    // let [currencyOptions, setCurrencyOptions] = useState([]);
    // let [expenseTypeOptions, setExpenseTypeOptions] = useState([]);

    const initialValues = {
        job_order_id: "",
        expense_type_id: "",
        expense_name: "",
        description: "",
        amount: "",
        currency_id: 101,
        attatchment: ""
    };

    const formik = useFormik({
        initialValues: initialValues,
        onSubmit: (values, { resetForm }) => {
            // console.log(values);
            let job_order_id = atob(b64id);
            if (job_order_id) {
                values.job_order_id = job_order_id;
            } else {
                toast.error("Job order is missing.");
                return;
            }

            console.log(values);

            if (!values.attatchment) {
                toast.error("Please upload a PDF file.");
                return;
            }

            // Prepare FormData
            const formData = new FormData();
            Object.keys(values).forEach((key) => {
                formData.append(key, values[key]);
            });
            setDisableSubmit(true);
            try {
                let config = {
                    headers: {
                        'auth-token': Cookies.get('token'),
                        'user_id': Cookies.get('flexichain_user_id'),
                        "Content-Type": "multipart/form-data",
                    }
                }
                axios.post(`${adminMainUrl}/api/jobOrder/operation/expense/create`, formData, config)
                    .then(response => {
                        if (response.status == 200) {
                            toast.success(response?.data?.msg);
                            setDisableSubmit(false);
                            resetForm();
                            formik.setFieldValue("attatchment", null);
                            handleClose();
                            refresh();
                        } else {
                            toast.error(response?.data?.msg);
                            setDisableSubmit(false);
                        }
                    }).catch(error => {
                        console.log(error)
                        toast.error(error.response.data.msg);
                        setDisableSubmit(false);
                    })
            } catch (error) {
                console.log(error.message);
                toast.error(error.message);
                setDisableSubmit(false);
            }
        }
    });


    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            if (file.type !== "application/pdf") {
                toast.error("Please upload a PDF file.");
                return;
            }
            formik.setFieldValue("attatchment", file);
        }
    };

    return (
        <>
            <Offcanvas show={show} onHide={handleClose} placement={"end"} name={"end"}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>Add Expense</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <form onSubmit={formik.handleSubmit}>
                        <div className="row">

                            <div className="col-md-6 mt-2">
                                <div className='ms-2'>
                                    <label htmlFor="" className='form-label  mb-0'>
                                        Expense Type
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <Select
                                            // styles={{ control: customControlStyles }}
                                            className='custom-selector'
                                            options={expenseTypeOptions}
                                            styles={customStyles}
                                            name="expense_type_id"
                                            onChange={option => {
                                                formik.setFieldValue('expense_type_id', option.value);
                                            }}
                                            value={expenseTypeOptions.find(option => option.value == formik.values.expense_type_id || null)}
                                            isLoading={loadingExpenseType}
                                        />
                                    </div>
                                </div>
                            </div>

                            <InputTextJSX labelText={"Expense Name"} nameValue={"expense_name"} value={formik.values.expense_name} onChange={formik.handleChange} maxLength={30} />

                            <div className={`col-md-12 mt-2`}>
                                <div className='ms-2'>
                                    <label htmlFor="" className='form-label  mb-0'>
                                        Description
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <textarea
                                            className="form-control"
                                            id={"description"}
                                            name={"description"}
                                            value={formik.values.description}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                        ></textarea>
                                    </div>
                                </div>
                            </div>

                            <div className={`col-md-6 mt-2`}>
                                <div className='ms-2'>
                                    <label htmlFor="" className='form-label  mb-0'>
                                        Amount
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input
                                            type='text'
                                            className="form-control form-control-sm"
                                            id={"amount"}
                                            name={"amount"}
                                            value={formik.values.amount}
                                            onChange={formik.handleChange}
                                            onBlur={formik.handleBlur}
                                            onInput={(event) => {
                                                let value = event.target.value;
                                                value = value.replace(/[^0-9.]/g, '');
                                                const parts = value.split('.');
                                                if (parts.length > 2) {
                                                    value = parts[0] + '.' + parts[1];
                                                }
                                                event.target.value = value;
                                            }}
                                            maxLength={15}
                                        ></input>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-6 mt-2">
                                <div className='ms-2'>
                                    <label htmlFor="" className='form-label  mb-0'>
                                        Currency
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <Select
                                            // styles={{ control: customControlStyles }}
                                            className='custom-selector'
                                            options={currencyOptions}
                                            styles={customStyles}
                                            name="currency_id"
                                            // onChange={option => {
                                            //     formik.setFieldValue('currency_id', option.value);
                                            // }}
                                            value={currencyOptions.find(option => option.value == formik.values.currency_id || null)}
                                            isLoading={loadingCurrency}
                                            isDisabled={true}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className={`col-md-6 mt-2`}>
                                <div className='ms-2'>
                                    <label htmlFor="" className='form-label  mb-0'>
                                        Attachment
                                    </label>
                                    <div className="icon-forms mb-3 mb-sm-0">
                                        <input
                                            type='file'
                                            className="form-control form-control-sm"
                                            id={"attatchment"}
                                            name={"attatchment"}
                                            accept='.pdf'
                                            onChange={handleFileChange}
                                        ></input>
                                    </div>
                                </div>
                            </div>

                        </div>
                        <div className="row d-flex justify-content-end mt-2">
                            <div className="col-md-6 d-flex justify-content-end">
                                <button type="submit" className="btn btn-sm btn-danger" disabled={disableSubmit}>
                                    {disableSubmit ? <><i className="fas fa-spinner fa-spin"></i> Saving...</> : "Add"}
                                </button>
                            </div>
                        </div>
                    </form>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    )
}

export default AddOperationExpenseOffcanvas